import integrationsService from "../shared/services/integrationsService";

const REQUEST_INTEGRATIONS_TYPES = "REQUEST_INTEGRATIONS_TYPES";
const RESPONSE_INTEGRATIONS_TYPES = "RESPONSE_INTEGRATIONS_TYPES";
const REQUEST_INTEGRATIONS_TYPES_FAILURE = "REQUEST_INTEGRATIONS_TYPES_FAILURE";

const requestGetIntegraionTypesAction = () => {
  return {
    type: REQUEST_INTEGRATIONS_TYPES,
  };
};

const responseGetIntegraionTypesAction = (data) => {
  return {
    type: RESPONSE_INTEGRATIONS_TYPES,
    data,
  };
};

const requesGetIntegraionTypesFailureAction = (errors) => {
  return {
    type: REQUEST_INTEGRATIONS_TYPES_FAILURE,
    errors,
  };
};

const getIntegraionTypes = () => {
  return (dispatch) => {
    dispatch(requestGetIntegraionTypesAction());

    integrationsService
      .getIngetrationsTypes()
      .then((result) => {
        dispatch(responseGetIntegraionTypesAction(result.data));
      })
      .catch((error) => {
        dispatch(requesGetIntegraionTypesFailureAction(error.response));
      });
  };
};

const REQUEST_INTEGRATIONS = "REQUEST_INTEGRATIONS";
const RESPONSE_INTEGRATIONS = "RESPONSE_INTEGRATIONS";
const REQUEST_INTEGRATIONS_FAILURE = "REQUEST_INTEGRATIONS_FAILURE";

const requestGetIntegraionsAction = () => {
  return {
    type: REQUEST_INTEGRATIONS,
  };
};

const responseGetIntegraionsAction = (data) => {
  return {
    type: RESPONSE_INTEGRATIONS,
    data,
  };
};

const requesGetIntegraionsFailureAction = (errors) => {
  return {
    type: REQUEST_INTEGRATIONS_FAILURE,
    errors,
  };
};

const getIntegraions = (options) => {
  return (dispatch) => {
    dispatch(requestGetIntegraionsAction());

    integrationsService
      .getIngetrations(options)
      .then((result) => {
        dispatch(responseGetIntegraionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requesGetIntegraionsFailureAction(error.response));
      });
  };
};

const REQUEST_INTEGRATION_CREATE = "REQUEST_INTEGRATION_CREATE";
const RESPONSE_INTEGRATION_CREATE = "RESPONSE_INTEGRATION_CREATE";
const REQUEST_INTEGRATION_CREATE_FAILURE = "REQUEST_INTEGRATION_CREATE_FAILURE";

const requestCreateIntegraionsAction = () => {
  return {
    type: REQUEST_INTEGRATION_CREATE,
  };
};

const responseCreateIntegraionsAction = (data) => {
  return {
    type: RESPONSE_INTEGRATION_CREATE,
    data,
  };
};

const requesCreateIntegraionsFailureAction = (errors) => {
  return {
    type: REQUEST_INTEGRATION_CREATE_FAILURE,
    errors,
  };
};

const createIntegraions = (options) => {
  return (dispatch) => {
    dispatch(requestCreateIntegraionsAction());

    integrationsService
      .createIngetration(options)
      .then((result) => {
        dispatch(responseCreateIntegraionsAction({ id: result.data.id, type: options.type, login: options.login }));
      })
      .catch((error) => {
        dispatch(requesCreateIntegraionsFailureAction(error.response));
      });
  };
};

const REQUEST_INTEGRATION_DELETE = "REQUEST_INTEGRATION_DELETE";
const RESPONSE_INTEGRATION_DELETE = "RESPONSE_INTEGRATION_DELETE";
const REQUEST_INTEGRATION_DELETE_FAILURE = "REQUEST_INTEGRATION_DELETE_FAILURE";

const requestDeleteeIntegraionsAction = () => {
  return {
    type: REQUEST_INTEGRATION_DELETE,
  };
};

const responseDeleteeIntegraionsAction = (data) => {
  return {
    type: RESPONSE_INTEGRATION_DELETE,
    data,
  };
};

const requesDeleteIntegraionsFailureAction = (errors) => {
  return {
    type: REQUEST_INTEGRATION_DELETE_FAILURE,
    errors,
  };
};

const deleteIntegraions = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteeIntegraionsAction());

    integrationsService
      .deleteIngetration(options)
      .then((result) => {
        dispatch(responseDeleteeIntegraionsAction(options));
      })
      .catch((error) => {
        dispatch(requesDeleteIntegraionsFailureAction(error.response));
      });
  };
};

export {
  REQUEST_INTEGRATIONS_TYPES,
  RESPONSE_INTEGRATIONS_TYPES,
  REQUEST_INTEGRATIONS_TYPES_FAILURE,
  getIntegraionTypes,
  REQUEST_INTEGRATIONS,
  RESPONSE_INTEGRATIONS,
  REQUEST_INTEGRATIONS_FAILURE,
  getIntegraions,
  REQUEST_INTEGRATION_CREATE,
  RESPONSE_INTEGRATION_CREATE,
  REQUEST_INTEGRATION_CREATE_FAILURE,
  createIntegraions,
  REQUEST_INTEGRATION_DELETE,
  RESPONSE_INTEGRATION_DELETE,
  REQUEST_INTEGRATION_DELETE_FAILURE,
  deleteIntegraions,
};
